module.exports = __webpack_public_path__ + "static/tasa_variable-2ef83180cf03facc17cec7f1bc3d3e63.png";